import angular from 'angular';
import dataSmartComponent from './data-smart.component';

let dataSmartModule = angular.module('dataSmart', [])

    .component('dSmart', dataSmartComponent) // 只能叫dSmart 叫dataSmart找不到组件

.name;

let states = [
  {
    name: 'dataSmart',
    url: '/data-intelligence',
    component: 'dSmart',
    title: 'face-data-smart-text001',
    description: 'face-data-smart-text001'
  }
];
export default {name: dataSmartModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/data-smart/data-smart.js